import React, { useState, useCallback, useMemo, Dispatch, SetStateAction, useEffect } from "react"
import Loader from "./UI/Loader.tsx";
import SlotDate from "./SlotDate/SlotDate.tsx";
import { AppointmentSteps, AppointmentTypes, onSelectAppointmentTypeCallback, onSelectDateCallback, Optional } from "../Models/Types.ts";
import Button from "./UI/Button.tsx";
import { capitalize } from "../Utils/StringFunctions.ts";
import { AppointmentRequest } from "../appointmentApi.tsx";

type AppointmentTypeChoise = AppointmentTypes | null;

interface TypeViewProps {
    onTypeButtonClick: (step: AppointmentSteps, type: AppointmentTypeChoise) => void;
}
function TypeView(props: TypeViewProps) {
    const { onTypeButtonClick } = props;

    return (
        <div id="container-step-appointment-type" className="container-step-appointment-type">
            <b>Per quale collezione desideri l'appuntamento?</b>
            <div className="container-button-step-large">
                <div onClick={() => onTypeButtonClick(AppointmentSteps.SLOTS_VIEW, AppointmentTypes.BRIDE)} id="button-collection-bride" className="button-appointment-type">Acquista abito da Sposa
                </div>
                <div onClick={() => onTypeButtonClick(AppointmentSteps.SLOTS_VIEW, AppointmentTypes.GROOM)} id="button-collection-groom" className="button-appointment-type">Acquista abito da Sposo
                </div>
                <div onClick={() => onTypeButtonClick(AppointmentSteps.MAN_QUANTITY_VIEW, AppointmentTypes.MAN)} id="button-collection-man" className="button-appointment-type">Acquista abito da Uomo
                </div>
                <div onClick={() => onTypeButtonClick(AppointmentSteps.WOMAN_QUANTITY_VIEW, AppointmentTypes.WOMAN)} id="button-collection-woman" className="button-appointment-type">Acquista abito da Donna
                </div>
                <div onClick={() => onTypeButtonClick(AppointmentSteps.WOMAN_QUANTITY_VIEW, AppointmentTypes.MAN_AND_WOMAN)} id="button-collection-womanandman" className="button-appointment-type">Acquista abito da Uomo e Donna
                </div>
            </div>
        </div>
    )
}

interface QuantitySelectionViewProps {
    selectedStep: AppointmentSteps,
    selectedType: AppointmentTypeChoise,
    setCustomersQuantity: Dispatch<SetStateAction<number>>,
    setSelectedStep: Dispatch<SetStateAction<AppointmentSteps>>,
    setAppointmentRequestForm: Dispatch<SetStateAction<AppointmentRequest>>
}
function QuantitySelectionView(props: QuantitySelectionViewProps) {
    const { selectedStep, selectedType, setCustomersQuantity, setSelectedStep, setAppointmentRequestForm } = props;

    const gender = useMemo(() => selectedStep === AppointmentSteps.MAN_QUANTITY_VIEW ? "man" : "woman", [selectedStep])
    const genderLabel = useMemo(() => gender === "woman" ? "donna" : "uomo", [gender]);
    const genderLabelPlural = useMemo(() => gender === "woman" ? "donne" : "uomini", [gender]);

    const quantities = useMemo(() => {
        const qtsArray = [1, 2, 3];
        if (selectedType !== AppointmentTypes.MAN_AND_WOMAN) {
            qtsArray.push(4);
        }
        return qtsArray;
    }, [selectedType])

    const onQuantityClick = useCallback((quantity: number) => {
        setCustomersQuantity(old => old + quantity);
        if (setAppointmentRequestForm) {
            if (selectedType === AppointmentTypes.MAN_AND_WOMAN && selectedStep === AppointmentSteps.WOMAN_QUANTITY_VIEW) {
                setAppointmentRequestForm(old => ({ ...old, womanNumber: quantity }))
                setSelectedStep(AppointmentSteps.MAN_QUANTITY_VIEW);
            } else if (selectedType === AppointmentTypes.MAN_AND_WOMAN && selectedStep === AppointmentSteps.MAN_QUANTITY_VIEW) {
                setAppointmentRequestForm(old => ({ ...old, manNumber: quantity }))
                setSelectedStep(AppointmentSteps.SLOTS_VIEW);
            } else if (selectedType === AppointmentTypes.MAN) {
                setAppointmentRequestForm(old => ({ ...old, manNumber: quantity }))
                setSelectedStep(AppointmentSteps.SLOTS_VIEW);
            } else if (selectedType === AppointmentTypes.WOMAN) {
                setAppointmentRequestForm(old => ({ ...old, womanNumber: quantity }))
                setSelectedStep(AppointmentSteps.SLOTS_VIEW);
            } else {
                setSelectedStep(AppointmentSteps.SLOTS_VIEW);
            }
        }

    }, [selectedType, selectedStep])

    return (
        <>
            <div id={`container-step-appointment-${gender}`} className="container-step-appointment-type">
                <b>Per quante donne desideri prendere l'appuntamento?</b>
                <div className="container-button-step-large">
                    {
                        quantities.map(quantity => <Button key={`step-quanitity-${gender}-${quantity}`} onClick={() => onQuantityClick(quantity)} className={`${gender}-quantity`}>
                            {quantity} {quantity === 1 ? capitalize(genderLabel) : capitalize(genderLabelPlural)}
                        </Button>)
                    }
                    <Button onClick={() => setCustomersQuantity(old => old + 5)}>Più di {`${quantities.at(-1)} ${capitalize(genderLabelPlural)}`}</Button>
                </div>
            </div>
        </>

    );
}

// interface ModalAppointmentProps {
//     setVisibleModal: Dispatch<SetStateAction<boolean>>
//     onSelectDate : onSelectDateCallback,
//     onSelectAppointmentType : onSelectAppointmentTypeCallback,
//     selectedStep : AppointmentSteps, 
//     setSelectedStep: Dispatch<SetStateAction<AppointmentSteps>>
// }

// const ModalAppointment: React.FC<Optional<ModalAppointmentProps, 'onSelectAppointmentType'>> = ({ setVisibleModal, onSelectDate, onSelectAppointmentType, selectedStep, setSelectedStep}) => {
interface ModalAppointmentProps {
    setVisibleModal: Dispatch<SetStateAction<boolean>>
    onSelectDate: onSelectDateCallback,
    selectedStep: AppointmentSteps,
    setSelectedStep: Dispatch<SetStateAction<AppointmentSteps>>,
    selectedType: AppointmentTypeChoise,
    setSelectedType: Dispatch<SetStateAction<AppointmentTypeChoise>>,
    setAppointmentRequestForm: Dispatch<SetStateAction<AppointmentRequest>>,
    appointmentRequestForm: AppointmentRequest
}

const ModalAppointment: React.FC<ModalAppointmentProps> = ({ setVisibleModal, onSelectDate, selectedStep, setSelectedStep, selectedType, setSelectedType, setAppointmentRequestForm, appointmentRequestForm }) => {

    const [visibleLoader, setVisibleLoader] = useState<boolean>(false)

    const [customersQuantity, setCustomersQuantity] = useState<number>(0);

    const onTypeButtonClick = useCallback(
        (step: AppointmentSteps, type: AppointmentTypeChoise) => {
            setSelectedStep(step);
            setSelectedType(type);
            if (type !== null) {
                if (type === AppointmentTypes.BRIDE) {
                    setAppointmentRequestForm(old => ({ ...old, manNumber: 0, womanNumber: 1, type: type }))
                } else if (type === AppointmentTypes.GROOM) {
                    setAppointmentRequestForm(old => ({ ...old, manNumber: 1, womanNumber: 0, type: type }))
                } else {
                    setAppointmentRequestForm(old => ({ ...old, manNumber: 0, womanNumber: 0, type: type }))
                }
            }
        },
        [setSelectedStep, setSelectedType],
    )

    useEffect(() => {
        if (customersQuantity > 4) {
            setSelectedStep(AppointmentSteps.QUANTITY_OVERFLOW);
            setCustomersQuantity(0);
            setSelectedType(null);
        }
    }, [customersQuantity])

    const onReturnButtonClick = useCallback(() => {
        if (selectedStep === AppointmentSteps.TYPE_VIEW) {
            setVisibleModal(false)
            onSelectDate(null);
        }
        else if (selectedType !== AppointmentTypes.MAN_AND_WOMAN) {
            setSelectedType(null);
            setSelectedStep(AppointmentSteps.TYPE_VIEW);
        }
        else {
            if (selectedStep === AppointmentSteps.MAN_QUANTITY_VIEW) {
                setSelectedStep(AppointmentSteps.WOMAN_QUANTITY_VIEW)
            }
            else {
                setSelectedStep(AppointmentSteps.TYPE_VIEW)
                setSelectedType(null);
            }
        }
        setCustomersQuantity(0)
    }, [selectedStep, selectedType, setVisibleModal, setCustomersQuantity])


    console.log({
        selectedStep,
        selectedType,
        customersQuantity
    })

    return <div id="modal-container" className="modal-container">
        <div className="modal-appointment-date">
            <div className="modal-header">
                <img onClick={onReturnButtonClick} id="back-to-form" className="icon" src="/calendario-appuntamenti/images/left-arrow.png" />
            </div>
            {/* <div className="container-param"> */}

            {
                selectedStep === AppointmentSteps.TYPE_VIEW &&
                <TypeView onTypeButtonClick={onTypeButtonClick} />
            }

            {
                (selectedStep === AppointmentSteps.WOMAN_QUANTITY_VIEW || selectedStep === AppointmentSteps.MAN_QUANTITY_VIEW) &&
                <QuantitySelectionView selectedStep={selectedStep} selectedType={selectedType} setCustomersQuantity={setCustomersQuantity} setAppointmentRequestForm={setAppointmentRequestForm} setSelectedStep={setSelectedStep} />
            }

            {
                selectedStep === AppointmentSteps.QUANTITY_OVERFLOW &&
                <div className="appointemnt-over-person">
                    <div>
                        Per appuntamenti superiori a 4 persone,
                    </div>
                    <div>
                        contattateci tramite WhatsApp o telefonicamente al numero 0966 21529.
                    </div>
                </div>
            }
            {
                selectedStep === AppointmentSteps.SLOTS_VIEW &&
                selectedType !== null &&
                <>
                    <SlotDate
                        appointmentType={selectedType}
                        womanNumber={appointmentRequestForm.womanNumber}
                        manNumber={appointmentRequestForm.manNumber}
                        onSelectDate={onSelectDate}
                    />
                </>
            }



            {/* </div> */}
        </div>
    </div>
}

export default ModalAppointment